import {
  ID_PRESUPUESTO_CONFIRMADO,
  ID_PRESUPUESTO_EN_PREPARACION,
  ID_PRESUPUESTO_PAGADO,
  ID_PRESUPUESTO_PENDIENTE
} from '../../constants/presupuesto.js'
import { esPresupuestoVencido } from '../presupuestoEstado.js'

const VALOR_VENCIDO = 'vencido'

const LABEL_POR_ESTADO = {
  [ID_PRESUPUESTO_PENDIENTE]: 'Pendiente',
  [ID_PRESUPUESTO_CONFIRMADO]: 'Confirmado',
  [ID_PRESUPUESTO_PAGADO]: 'Pagado',
  [ID_PRESUPUESTO_EN_PREPARACION]: 'En preparación',
  [VALOR_VENCIDO]: 'Vencido'
}

const obtenerValorEstado = (p) =>
  esPresupuestoVencido(p.idEstado, p.fechaValidez) ? VALOR_VENCIDO : p.idEstado

export const MAPA_PRESUPUESTOS = {
  idEstado: {
    titulo: 'Estado',
    opciones: ({ presupuestos = [] }) => [
      ...new Map(
        presupuestos.map((p) => {
          const valor = obtenerValorEstado(p)
          return [valor, { valor, label: LABEL_POR_ESTADO[valor] ?? p.estado }]
        })
      ).values()
    ],
    filterFn: (p, v) => obtenerValorEstado(p) === v
  },

  empresaCompradora: {
    titulo: 'Empresa compradora',
    opciones: ({ presupuestos = [] }) => [
      ...new Map(
        presupuestos.map((p) => [
          p.empidComprador,
          { label: p.razonSocial, valor: p.empidComprador }
        ])
      ).values()
    ],
    filterFn: (p, v) => p.empidComprador === v
  },

  empresaVendedora: {
    titulo: 'Empresa vendedora',
    opciones: ({ presupuestos = [] }) => [
      ...new Map(
        presupuestos.map((p) => [p.empidVendedor, { label: p.razonSocial, valor: p.empidVendedor }])
      ).values()
    ],
    filterFn: (p, v) => p.empidVendedor === v
  },

  vendedor: {
    titulo: 'Vendedor',
    opciones: ({ presupuestos = [] }) => [
      ...new Map(
        presupuestos.map((p) => [p.idVendedor, { label: p.nombreVendedor, valor: p.idVendedor }])
      ).values()
    ],
    filterFn: (p, v) => p.idVendedor === v
  },

  comprador: {
    titulo: 'Comprador',
    opciones: ({ presupuestos = [] }) => [
      ...new Map(
        presupuestos.map((p) => [p.idUsuario, { label: p.nombreComprador, valor: p.idUsuario }])
      ).values()
    ],
    filterFn: (p, v) => p.idUsuario === v
  },

  textoBusqueda: {
    placeholder: 'Buscar por título o NRO presupuesto',
    filterFn: (p, v) => {
      const val = v.trim().toLowerCase()
      if (!val) return true
      return (
        (p.titulo || '').toLowerCase().includes(val) ||
        (p.idPresupuesto || '').toString().includes(val)
      )
    }
  }
}
